import React from 'react';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

const AnimatedCursor = React.lazy(() => import('./dotCursor'));
export const CustomCursor = () => {
  const isSSR = typeof window === 'undefined';

  const breakpoints = useBreakpoint();

  return breakpoints.lg ? (
    <>
      {!isSSR && (
        <React.Suspense fallback={<div />}>
          <AnimatedCursor />
        </React.Suspense>
      )}
    </>
  ) : null;
};
